<div class="row justify-content-center  full-hight login ">

  <div class=" row justify-content-center ">
    <div class="col-10">
      <h1 class="titleBookk">{{ 'CONNEXION.TITLE' | translate }}</h1>
    </div>
    <div class="col-11">
      <div class="row justify-content-center">

        <div *ngIf="!_isTry; then formLoginBlock else loginLoad"></div>
        <ng-template #formLoginBlock>

          
          <!-- <div class="col-12">
            <div class="form-group row">
              <h3 for="login" class="col-sm-4 col-form-label main-input inputlogin">{{ 'CONNEXION.LOGIN' | translate }}</h3>
              <div class="col-sm-5">
                <input type="text" class="form-control main-input" id="login" [(ngModel)]="formUser.username"
                  #ctrl="ngModel">
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group row">
              <h3 for="inputPassword" class="col-sm-4 col-form-label main-input inputlogin">{{ 'CONNEXION.PASSWORD' | translate }}</h3>
              <div class="col-sm-5">

                
                <mat-form-field>
                <input class=" main-input" id="inputPassword"
                [type]="hide ? 'password' : 'text'"  [(ngModel)]="formUser.password" #ctrl="ngModel">
                <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                  <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>
          </div> -->

               
        <form class="col-12" [formGroup]="formGroup" (ngSubmit)="signIn()">

         

          <div class="row justify-content-center">
            <mat-form-field class="col-md-6 col-12">
              <input matInput placeholder="Identifiant" formControlName="username" required>
              <mat-error *ngIf="!formGroup.controls['username'].valid && formGroup.controls['username'].touched">
                {{ getErrorUsername() }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="row justify-content-center">
            <mat-form-field  class="col-md-6 col-12">
              <input matInput placeholder="Mot de passe" formControlName="password" [type]="hide ? 
              'password' : 'text'" required>
              <mat-icon style="cursor: pointer" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 
                'visibility'}}</mat-icon>
              <mat-error *ngIf="!formGroup.controls['password'].valid && formGroup.controls['password'].touched">
                {{ getErrorPassword() }}
              </mat-error>
            </mat-form-field>
          </div>

        </form>

      

          <div class="col-12  align-self-center mt-2">
            <div class="row justify-content-center">
              <div class="col-md-6 col-12">
                <button mat-flat-button color="primary" class="full-width main-button"
                  (click)='signIn()'>{{ 'CONNEXION.BOUTONCNX' | translate }}</button>
              </div>
            </div>
          </div>
          <div class="col-12  align-self-center marge mt-2">
            <div class="row justify-content-center">
              <div class="col-8 " style="text-align: center">
                <a href="/connexion/lost-password" class="main-link sec-data">{{ 'CONNEXION.FORGET' | translate }}</a>
              </div>
            </div>
          </div>


          <div class="col-12">
            <h1 class="titleBookk">{{ 'CONNEXION.NOTSUBSCRIBE' | translate }}</h1>
          </div>
          <div class="col-12  align-self-center">
            <div class="row justify-content-center">
              <div class="col-md-6 col-12">
                <a [href]="url"><button (click)="removeSubscribe()" mat-flat-button color="primary"
                    class="full-width main-button">{{ 'CONNEXION.BOUTONSUBSCRIBE' | translate }}</button></a>
              </div>
            </div>
          </div>


        </ng-template>
        <ng-template #loginLoad>
          <app-default-clem-loading [loadingText]="'Connexion en cours'"></app-default-clem-loading>
        </ng-template>

      </div>

    </div>

  </div>
</div>
